import EventEmitter from "eventemitter3";
import forEach from "lodash/forEach";
import set from "lodash/set";

import WebAPIRequest from "./WebAPIRequest";

export default class WebAPI {
    constructor() {
        this.eventEmitter = new EventEmitter();
        this.requestPool = {};

        this.clearRequestPool = this.clearRequestPool.bind(this);
        this.initEventListeners();
    }

    createRequest(type, url, options) {
        this.clearRequestPool();

        /**
         * Don't make a new request to the same endpoint if another one is still
         * in progress.
         */
        if (this.requestPool[url] && !(this.requestPool[url].ended || this.requestPool[url].aborted)) {
            return this.requestPool[url];
        }

        const request = new WebAPIRequest(type, url, options, this.eventEmitter);
        set(this.requestPool, request.url, request);

        return request;
    }

    clearRequestPool() {
        forEach(this.requestPool, request => {
            if (request.ended || request.aborted) {
                delete this.requestPool[request.url];
            }
        });
    }

    abortAllRequests() {
        forEach(this.requestPool, request => request.abort());
    }

    initEventListeners() {
        /**
         * 'this.eventEmitter' is passed down to WebAPIRequest where we then
         * emit 'request-end' when the ajax call finishes.
         */
        this.eventEmitter.on("request-end", this.clearRequestPool);
    }
}
